var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c(
          "div",
          {
            staticClass: "page-header-top-container",
            staticStyle: { width: "100% !important" }
          },
          [
            _c("div", { staticClass: "page-name" }, [
              _vm._v(_vm._s(_vm.pageTitle))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary waves-effect pull-right",
                attrs: { type: "submit" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.buttonBack()
                  }
                }
              },
              [_vm._v("Back")]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { class: _vm.alertClass, attrs: { id: "success-alert" } }, [
            _c("strong", [_vm._v(" " + _vm._s(_vm.alertMessage) + " ")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "forms-container add_user_forms_container" },
            [
              _c(
                "div",
                { staticClass: "row no-margin" },
                [
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-9 paddingleft0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.firstName,
                            expression: "firstName"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "firstName",
                          placeholder: "Enter First Name"
                        },
                        domProps: { value: _vm.firstName },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.firstName = $event.target.value
                            },
                            function($event) {
                              _vm.firstNameError = ""
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.firstNameError))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-9 paddingleft0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.lastName,
                            expression: "lastName"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "lastName",
                          placeholder: "Enter Last Name"
                        },
                        domProps: { value: _vm.lastName },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.lastName = $event.target.value
                            },
                            function($event) {
                              _vm.lastNameError = ""
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.lastNameError))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-9 paddingleft0" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.email,
                            expression: "email"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { id: "email", placeholder: "Enter Email" },
                        domProps: { value: _vm.email },
                        on: {
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.email = $event.target.value
                            },
                            function($event) {
                              _vm.emailError = ""
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.emailError))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.isNonVVGDealer == "NO"
                    ? [
                        _c("div", { staticClass: "col-6 forms-block" }, [
                          _vm._m(3),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-9 paddingleft0" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.dayforceId,
                                  expression: "dayforceId"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                id: "dayforceId",
                                placeholder: "Enter DayforceId"
                              },
                              domProps: { value: _vm.dayforceId },
                              on: {
                                input: [
                                  function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.dayforceId = $event.target.value
                                  },
                                  function($event) {
                                    _vm.dayforceIdError = ""
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "requiredstar" }, [
                              _vm._v("*")
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.dayforceIdError))
                            ])
                          ])
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(4),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c(
                          "v-select",
                          {
                            attrs: {
                              name: "roleId",
                              id: "roleId",
                              label: "name",
                              filterable: true,
                              options: _vm.roleOptions,
                              clearable: false,
                              placeholder: "Select Role"
                            },
                            on: {
                              input: function($event) {
                                return _vm.onChangeRole()
                              }
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "option",
                                fn: function(option) {
                                  return [
                                    _c("div", { staticClass: "d-center" }, [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(option.name) +
                                          "\n                                    "
                                      )
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "selected-option",
                                fn: function(option) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "selected d-center" },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(option.name) +
                                            "\n                                    "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.roleId,
                              callback: function($$v) {
                                _vm.roleId = $$v
                              },
                              expression: "roleId"
                            }
                          },
                          [
                            _c("template", { slot: "no-options" }, [
                              _vm._v(
                                "\n                                    Search Role...\n                                "
                              )
                            ])
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "requiredstar" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.roleError))
                        ])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm.isNonVVGDealer == "YES"
                    ? [
                        _c("div", { staticClass: "col-6 forms-block" }, [
                          _vm._m(5),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-9 paddingleft0" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.password,
                                  expression: "password"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                id: "toggle-password",
                                type: "password",
                                placeholder: "Enter Password",
                                name: "password"
                              },
                              domProps: { value: _vm.password },
                              on: {
                                input: [
                                  function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.password = $event.target.value
                                  },
                                  function($event) {
                                    _vm.passwordError = ""
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.isEdit,
                                    expression: "!isEdit"
                                  }
                                ],
                                staticClass: "requiredstarPassword"
                              },
                              [_vm._v("*")]
                            ),
                            _vm._v(" "),
                            _c("span", {
                              staticClass:
                                "fa fa-lg fa-eye field-icon toggle-password",
                              staticStyle: {
                                position: "absolute",
                                top: "9px",
                                right: "25px",
                                cursor: "pointer",
                                "z-index": "2"
                              },
                              attrs: { toggle: "#toggle-password" }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.passwordError))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-6 forms-block" }, [
                          _vm._m(6),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-9 paddingleft0" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.confirmPassword,
                                  expression: "confirmPassword"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                id: "toggle-password-confirm",
                                type: "password",
                                name: "confirmPassword",
                                placeholder: "Confirm Password"
                              },
                              domProps: { value: _vm.confirmPassword },
                              on: {
                                input: [
                                  function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.confirmPassword = $event.target.value
                                  },
                                  function($event) {
                                    _vm.confirmPasswordError = ""
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.isEdit,
                                    expression: "!isEdit"
                                  }
                                ],
                                staticClass: "requiredstarPassword"
                              },
                              [_vm._v("*")]
                            ),
                            _vm._v(" "),
                            _c("span", {
                              staticClass:
                                "fa fa-lg fa-eye field-icon toggle-password-confirm",
                              staticStyle: {
                                position: "absolute",
                                top: "9px",
                                right: "25px",
                                cursor: "pointer",
                                "z-index": "2"
                              },
                              attrs: { toggle: "#toggle-password-confirm" }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.confirmPasswordError))
                            ])
                          ])
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isMappedListShow
                    ? _c("div", { staticClass: "col-6 forms-block" }, [
                        _vm._m(7),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-9 paddingleft0" },
                          [
                            _c(
                              "v-select",
                              {
                                staticClass: "multi-select-list",
                                attrs: {
                                  multiple: "",
                                  name: "mappedId",
                                  id: "mappedId",
                                  label: "text",
                                  filterable: false,
                                  options: _vm.mappedArr,
                                  placeholder: _vm.mappedPlaceholder
                                },
                                on: {
                                  change: _vm.changedValue,
                                  input: function($event) {
                                    return _vm.changedValueMappedList()
                                  },
                                  search: _vm.onSearchMappedList
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "option",
                                      fn: function(option) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "d-center" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(option.text) +
                                                  "\n                                    "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    },
                                    {
                                      key: "selected-option",
                                      fn: function(option) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "selected d-center"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(option.text) +
                                                  "\n                                    "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  4278825124
                                ),
                                model: {
                                  value: _vm.mappedId,
                                  callback: function($$v) {
                                    _vm.mappedId = $$v
                                  },
                                  expression: "mappedId"
                                }
                              },
                              [
                                _c("template", { slot: "no-options" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.mappedSearch) +
                                      "\n                                "
                                  )
                                ])
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 forms-block" }, [
                    _vm._m(8),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-9 paddingleft0" },
                      [
                        _c("v-select", {
                          staticClass: "multi-select-list",
                          attrs: {
                            multiple: "",
                            name: "locationId",
                            id: "locationId",
                            label: "name",
                            filterable: true,
                            options: _vm.locationArr,
                            clearable: false,
                            placeholder: "Select Location"
                          },
                          on: {
                            input: function($event) {
                              return _vm.onChnageLocation()
                            }
                          },
                          model: {
                            value: _vm.locationId,
                            callback: function($$v) {
                              _vm.locationId = $$v
                            },
                            expression: "locationId"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row no-margin checkbox_container" }, [
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(9),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _vm._l(_vm.allPermissions, function(
                        allPermission,
                        index
                      ) {
                        return [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.checkedPermissionAddTime,
                                expression: "checkedPermissionAddTime"
                              }
                            ],
                            key: allPermission.id,
                            attrs: { type: "checkbox", name: "permission[]" },
                            domProps: {
                              value: allPermission.id,
                              checked: Array.isArray(
                                _vm.checkedPermissionAddTime
                              )
                                ? _vm._i(
                                    _vm.checkedPermissionAddTime,
                                    allPermission.id
                                  ) > -1
                                : _vm.checkedPermissionAddTime
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.checkedPermissionAddTime,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = allPermission.id,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.checkedPermissionAddTime = $$a.concat(
                                        [$$v]
                                      ))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.checkedPermissionAddTime = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.checkedPermissionAddTime = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" " + _vm._s(allPermission.name)),
                          _c("br")
                        ]
                      })
                    ],
                    2
                  )
                ])
              ]),
              _vm._v(" "),
              _vm._m(10),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c("div", { staticClass: "row clearfix" }),
              _vm._v(" "),
              _c("div", { staticClass: "button-demo" }, [
                _c("input", {
                  staticClass: "btn btn-primary my-1 ms-2",
                  attrs: {
                    id: "addBenifitBtn",
                    disabled: _vm.disableButtons.save,
                    type: "submit"
                  },
                  domProps: { value: _vm.buttonNames.save },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.addUpdateUser()
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "btn btn-primary my-1 ms-2",
                  attrs: {
                    id: "addAndContinueBenifitBtn",
                    disabled: _vm.disableButtons.saveAndContinue,
                    type: "submit"
                  },
                  domProps: { value: _vm.buttonNames.saveAndContinue },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.addUpdateUser((_vm.flag = "Save and Continue"))
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "btn btn-primary my-1 ms-2",
                  attrs: {
                    id: "CancelBenifit",
                    disabled: _vm.disableButtons.cancel,
                    type: "submit"
                  },
                  domProps: { value: _vm.buttonNames.cancel },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.buttonBack.apply(null, arguments)
                    }
                  }
                })
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("First Name :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Last Name :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Email : ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("DayforceId: ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Role :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Password :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Confirm Password :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("List :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Location :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Permissions :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row clearfix" }, [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17e05e01", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17e05e01","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/AddUpdateUser.vue
// module id = null
// module chunks = 